export function organizationPath(organization) {
  const slug = organization.name
    .normalize("NFKD")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, "-")
    .replace(/^-|-$/g, "") || "organisation";

  return `/admin/organisations/${organization.id}-${slug}`;
}
